import {useEffect, useState} from 'react'
import { Link, useNavigate } from "react-router-dom";
import { ReactSVG } from "react-svg";
import api from '../../api/api';
import { FaAngleDown, FaGlobe, FaInfoCircle, FaLock, FaPlus, FaSearch } from "react-icons/fa";
import { FiLogOut } from "react-icons/fi";
import { toast } from 'react-toastify';
import { FaAngleRight } from 'react-icons/fa6';
import i18next from 'i18next';
import { useTranslation } from 'react-i18next'
import { useProfileStore } from '../../store/useUserStore';
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { driver } from 'driver.js';

const Profile = () => {
    const [parentData, setParentData] = useState({
        name:"",
        email: "",
        ic: "",
        birthday: "",
        profilePic:"/assets/img/default-profile.jpg",
        phone: ""
    })
    const [students, setStudents] = useState([])
    const navigate = useNavigate()
    const [expandChangePassword, setExpandChangePassword] = useState(false)
    const [expandChangeLanguage, setExpandChangeLanguage] = useState(false)
    const [newPassword, setNewPassword] = useState("")
    const [confirmPassword, setConfirmPassword] = useState("")
    const { t } = useTranslation()
    const {profile, setLoading, logout, showGuidanceFlow, guidanceStep, setShowGuidanceFlow, setGuidanceStep} = useProfileStore((state) => state)

    useEffect(() => {
        if (profile) {
            getStudents()
            setParentData({
                name: profile.name || "",
                email: profile.email || "",
                ic: profile.ic_number || "",
                birthday: profile.birthday || "",
                profilePic: profile.profile_pic || "/assets/img/default-profile.jpg",
                phone: profile.phone || ""
            })
        }
    }, [profile])

    // Driver.js guidance for Add Child step
    useEffect(() => {
        if (showGuidanceFlow && guidanceStep === 'add-child') {
            const driverObj = driver({
                showProgress: false,
                showButtons: [],
                steps: [
                    {
                        element: '#add-child-button',
                        popover: {
                            description: "<img style='width: 170px; height: 166.65px;' src='/assets/img/2.png' />",
                            side: "top",
                            align: 'center',
                            onPopoverRender: (popover, { config }) => {
                                // make popover not white
                                const popoverElement = popover.wrapper;
                                popoverElement.style.backgroundColor = 'transparent';

                                // make popover no shadow box
                                popoverElement.style.boxShadow = 'none';

                                const popoverDescription = popoverElement.querySelector('#driver-popover-description') as HTMLElement;
                                if (popoverDescription) {
                                    popoverDescription.style.textAlign = 'center';
                                    // popoverDescription.style.transform = 'translateY(24%)';
                                }
                            },
                            showButtons: []
                        }
                    }
                ],
                onDestroyed: () => {
                    setShowGuidanceFlow(false)
                    setGuidanceStep(null)
                },
                onPopoverRender: (popover, { config }) => {
                    // Custom styling for the popover
                    const popoverElement = popover.wrapper;
                    // popoverElement.style.zIndex = '2002';
                    
                    // Center the text content
                    const descriptionElement = popoverElement.querySelector('.driver-popover-description') as HTMLElement;
                    
                    if (descriptionElement) {
                        descriptionElement.style.textAlign = 'center';
                    }
                }
            })
            driverObj.drive()
        }
    }, [showGuidanceFlow, guidanceStep, t, setShowGuidanceFlow, setGuidanceStep])
    
    function getStudents() {
        setLoading(true)
        api.get(`${process.env.REACT_APP_API_BASE_URL}/student`).then( res => {
            console.log("res student", res.data.result.data)
            setStudents( res.data.result.data)
        }).catch( err => {
            console.log("err", err)
        }).finally(() => {
            setLoading(false)
        })
    }

    function handleLogout() {
        logout()
        window.location.reload()
    }

    function handleChangePassword(values: {newPassword: string, confirmPassword: string}) {
        if (values.newPassword !== values.confirmPassword) return toast.error("Password not match")

        setLoading(true)
        api.post(`${process.env.PUBLIC_URL}/user/change-password`, {
            "password": values.newPassword,
            "confirm_password": values.confirmPassword
        }).then(res => {
            setExpandChangePassword(false)
            setNewPassword("")
            setConfirmPassword("")
            setLoading(false)
            toast.success("Succesfully changed password")
        }).catch(err =>{
            console.log("err", err)
            setLoading(false)
            toast.error("Server Error")
        })
    }

    const validationSchema = Yup.object().shape({
        newPassword: Yup.string()
            .min(6, t('validation.password_min'))
            .required(t('validation.required')),
        confirmPassword: Yup.string()
            .oneOf([Yup.ref('newPassword'), undefined], t('validation.password_match'))
            .required(t('validation.required'))
    });


    return (
        <>
        <div className="pb-28 text-black">
            <div className="mb-10">
                <div className="flex flex-col items-center text-center">
                    <div className="w-24 h-24 mb-4">
                        <img src={parentData.profilePic} alt="" className="w-full h-full rounded-full object-cover" />
                    </div>
                    <h3 className="text-lg font-bold mb-2">{parentData.name}</h3>
                    <div className="w-full">
                        <div className="text-sm font-normal text-gray-700 mb-1">{parentData.ic}</div>
                    </div>
                </div>
            </div>

           <div className="px-4 pt-4 pb-8">
                {/* Profile Info Table */}
                <div className="rounded-xl bg-white border-2 mb-10">
                    <div className="flex items-center justify-between px-4 py-4 border-b-2">
                        <div className="text-sm font-medium w-1/2">{t('profile.name')}</div>
                        <div className="text-xs font-light w-1/2 text-right">{parentData.name}</div>
                    </div>
                    <div className="flex items-center justify-between px-4 py-4 border-b-2">
                        <div className="text-sm font-medium w-1/2">{t('profile.ic')}</div>
                        <div className="text-xs font-light w-1/2 text-right">{parentData.ic}</div>
                    </div>
                    <div className="flex items-center justify-between px-4 py-4 border-b-2">
                        <div className="text-sm font-medium w-1/2">{t('profile.phone')}</div>
                        <div className="text-xs font-light w-1/2 text-right">{parentData.phone || "-"}</div>
                    </div>
                    <div className="flex items-center justify-between px-4 py-4 border-b-2">
                        <div className="text-sm font-medium w-1/2 break-words truncate pr-2">{t('profile.email')}</div>
                        <div className="text-xs font-light w-1/2 text-right break-words truncate pl-2">{parentData.email}</div>
                    </div>
                    <div className="flex items-center justify-between px-4 py-4 border-b-2">
                        <div className="text-sm font-medium w-1/2">{t('profile.birthday')}</div>
                        <div className="text-xs font-light w-1/2 text-right">{parentData.birthday}</div>
                    </div>
                    <div className="flex items-center justify-between px-4 py-4">
                        <div className="text-sm font-medium w-1/2">{t('profile.edit_profile')}</div>
                        <div className="w-1/2 text-right">
                            <Link to={"/profile/edit"}>
                            <ReactSVG src={"/assets/img/icons/edit.svg"} className="w-4 h-4 inline-block" />
                            </Link>
                        </div>
                    </div>
                </div>

                {/* Manage Children */}
                <div className="text-lg font-medium mb-2">{t('profile.manage_child')}</div>

                <div className="rounded-lg bg-white mb-8 relative">
                    {students.map((student:any, index:any) => (
                    <div key={index} className="flex items-center border-b-2 p-3 cursor-pointer" onClick={() => navigate(`/children/edit/${student.id}`)} >
                        <div className="w-10 h-10 mr-4">
                            <img src={student.profile_pic || "/assets/img/default-profile.jpg"} alt="" className="w-full h-full rounded-full object-cover" />
                        </div>
                        <div className="text-sm font-medium flex-1">{student.name}</div>
                        <FaAngleRight/>
                    </div>
                    ))}
                    <div 
                        id="add-child-button"
                        className={`flex items-center border-b-2 p-3 cursor-pointer ${showGuidanceFlow && guidanceStep === 'add-child' ? 'relative' : ''}`} 
                        onClick={() => {
                            if (showGuidanceFlow && guidanceStep === 'add-child') {
                                setShowGuidanceFlow(false)
                                setGuidanceStep(null)
                                driver().destroy();
                            }
                            navigate("/children/add")
                        }}
                    >
                        <div className="h-8"></div>
                        <div className="text-sm font-medium flex-1">{t('profile.add_child')}</div>
                        <FaPlus />
                    </div>
                </div>

                {/* Change Password */}
                <div className="p-3 border-2 mb-6 border-gray-300 rounded-xl">
                    <div className="grid grid-cols-10 items-center">
                    <FaLock className="mr-2 col-span-1 justify-self-center" />
                    <div className="col-span-8 font-semibold">{t('profile.change_password')}</div>
                    {expandChangePassword ? (
                        <FaAngleDown className="col-span-1 justify-self-center cursor-pointer" onClick={() => setExpandChangePassword(false)} />
                    ) : (
                        <FaAngleRight className="col-span-1 justify-self-center cursor-pointer" onClick={() => setExpandChangePassword(true)} />
                    )}
                    </div>

                    {expandChangePassword && (
                    <Formik
                        initialValues={{
                            newPassword: "",
                            confirmPassword: ""
                        }}
                        validationSchema={validationSchema}
                        onSubmit={(values, { resetForm, setSubmitting }) => {
                            handleChangePassword(values)
                            resetForm() // Clears the form after submission
                            setSubmitting(false)
                        }}>
                        {({ isSubmitting }) => (
                        <Form className="mt-4">
                            <div className="mb-3 mx-3">
                                <label className="text-md font-medium mb-2">{t('profile.new_password')}</label>
                                <Field
                                    type="password"
                                    name="newPassword"
                                    className="w-full px-4 py-2 border rounded-full text-md focus:outline-none focus:ring-2 focus:ring-theme"
                                />
                                <ErrorMessage name="newPassword" component="div" className="ml-4 pt-1 text-red-500 text-sm mt-1" />
                            </div>

                            <div className="mb-3 mx-3">
                            <label className="text-md font-medium mb-2">{t('profile.confirm_new_password')}</label>
                            <Field
                                type="password"
                                name="confirmPassword"
                                className="w-full px-4 py-2 border rounded-full text-md focus:outline-none focus:ring-2 focus:ring-theme"
                            />
                            <ErrorMessage name="confirmPassword" component="div" className="ml-4 pt-1 text-red-500 text-sm mt-1" />
                            </div>

                            <div className="flex justify-center">
                                <button 
                                    type="submit" 
                                    className="justify-self-center text-white font-semibold text-[16px] leading-none w-1/2 py-[15px] bg-black border-none rounded-3xl flex items-center justify-center"
                                    disabled={isSubmitting}
                                >
                                    {t('profile.update')}
                                </button>
                            </div>
                        </Form>
                        )}
                    </Formik>
                    )}
                </div>

                {/* Change Language */}
                <div className="p-3 border-2 mb-6 border-gray-300 rounded-xl">
                    <div className="grid grid-cols-10 items-center">
                        <FaGlobe className="mr-2 col-span-1 justify-self-center" />
                        <div className="col-span-8 font-semibold">{t('profile.change_language')}</div>
                        {expandChangeLanguage ? (
                            <FaAngleDown className="col-span-1 justify-self-center cursor-pointer" onClick={() => setExpandChangeLanguage(false)} />
                        ):(
                            <FaAngleRight className="col-span-1 justify-self-center cursor-pointer" onClick={() => setExpandChangeLanguage(true)} />
                        )}
                    </div>
                    {expandChangeLanguage && (
                    <div className="mt-4">
                        <div className="mb-3 ml-4 cursor-pointer" onClick={() => i18next.changeLanguage("en")}>
                        <div className="text-md font-medium">English</div>
                        </div>
                        <div className="mb-3 ml-4 cursor-pointer" onClick={() => i18next.changeLanguage("zh")}>
                        <div className="text-md font-medium">Mandarin</div>
                        </div>
                        <div className="mb-3 ml-4 cursor-pointer" onClick={() => i18next.changeLanguage("ms")}>
                        <div className="text-md font-medium">Bahasa Malaysia</div>
                        </div>
                    </div>
                    )}
                </div>

                <a href="https://forms.gle/9Ts6GhTrNxxa6KYN8" target="_blank" rel="noopener noreferrer" className="block p-3 bg-[#fecc1a] mb-6 rounded-xl hover:text-black active:text-black focus:text-black" >
                    <div className="grid grid-cols-10 items-center">
                    <FaInfoCircle className="mr-2 col-span-1 justify-self-center" />
                    <div className="col-span-8 font-semibold">{t('profile.help_centre')}</div>
                    </div>
                </a>

                {/* Logout */}
                <div className="flex justify-center">
                    <div className="w-1/2 bg-red-600 rounded-lg">
                        <div className="flex items-center px-6 py-3 text-white cursor-pointer" onClick={() => handleLogout()}>
                            <FiLogOut size={16} />
                            <div className="flex-1 font-medium text-sm text-center">{t('profile.logout')}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </>
    );
}

export default Profile;
